export const stats = [
  { number: "10+", label: "Projets Réalisés" },
  { number: "2+", label: "Années d'Expérience" },
  { number: "10+", label: "Clients Satisfaits" },
  { number: "Madagascar", label: "Lieux Couvertes" }
];

export const navItems = [
  { label: 'Accueil', id: 'home' },
  { label: 'Services', id: 'services' },
  { label: 'Portfolio', id: 'portfolio' },
  { label: 'À Propos', id: 'about' },
  { label: 'Témoignages', id: 'testimonials' },
  { label: 'Contact', id: 'contact' }
];

export const projectTypes = [
  { value: '', label: 'Sélectionner un type de projet' },
  { value: 'Villa / Maison individuelle', label: 'Villa / Maison individuelle' },
  { value: 'Appartement / Rénovation', label: 'Appartement / Rénovation' },
  { value: 'Commerce / Bureau', label: 'Commerce / Bureau' },
  { value: 'Bâtiment industriel', label: 'Bâtiment industriel' },
  { value: 'Projet mixte', label: 'Projet mixte' },
  { value: 'Autre', label: 'Autre' }
];

export const budgetRanges = [
  { value: '', label: 'Sélectionner une fourchette' },
  { value: 'Moins de 500 000 Ar', label: 'Moins de 500 000 Ar' },
  { value: '500 000 - 1 000 000 Ar', label: '500 000 - 1 000 000 Ar' },
  { value: '1 000 000 - 2 000 000 Ar', label: '1 000 000 - 2 000 000 Ar' },
  { value: '2 000 000 - 5 000 000 Ar', label: '2 000 000 - 5 000 000 Ar' },
  { value: 'Plus de 5 000 000 Ar', label: 'Plus de 5 000 000 Ar' }
];

export const businessHours = [
  { day: 'Lundi - Vendredi', hours: '8:30 - 17:00' },
  { day: 'Samedi', hours: '8:30 - 13:00' },
  { day: 'Dimanche', hours: 'Fermé' }
];

export const contactInfo = {
  phones: ['+261349838111', '+261331642383'],
  email: 'conceptdesignma@gmail.com',
  whatsapp: '261349838111',
  facebook: 'https://www.facebook.com/profile.php?id=61579861155432',
  linkedin: 'https://www.linkedin.com/company/m-a-concept/posts/?feedView=all'
};

export const emailConfig = {
  serviceId: 'service_68iqopf',
  templateId: 'template_0rbeddw',
  publicKey: 'zdktpGXKNobTcjCmc',
  toEmail: 'randrianasolo.clementvictorin@gmail.com'
};
